module.exports = __webpack_public_path__ + "static/img/topImg.5e3ec79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/topImg.jpg
// module id = OHxf
// module chunks = 1